window.addEventListener('DOMContentLoaded', () => {
	let header = document.querySelector('.header');
	let state = false;
	
	function scroll() {
		let newState = (window.scrollY > 50);
		if (newState !== state) {
			if (newState) {
				header.classList.add('header_dark');
			} else {
				header.classList.remove('header_dark');
			}
			
			state = newState;
		}
	}
	
	document.addEventListener('scroll', scroll);
	scroll();
});